import styles from './UploadQuotesUnput.module.scss';
import { ReactComponent as UploadSVG } from 'assets/image/upload-icon.svg';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { LocalizedStringsMap, SupportedLanguageKey } from 'core/constants';
import { parseQuotesXlsx, validateUploadedQuotesList } from './helpers';
import Dropzone from 'react-dropzone';

export type UploadedQuoteErrors = Partial<Record<SupportedLanguageKey | 'startDate' | 'nonUniqueDate', string>>;

export type UploadedQuote = {
	startDate?: Date;
	messages: LocalizedStringsMap;
	errors?: UploadedQuoteErrors;
};

interface IUploadQuotesInputProps {
	handleInput: (quotes: Array<UploadedQuote>) => void;
	setErrorsCount: React.Dispatch<React.SetStateAction<number>>;
}

export const UploadQuotesInput: FC<IUploadQuotesInputProps> = ({ handleInput, setErrorsCount }) => {
	const [file, setFile] = useState<File>();

	const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		if (e.target.files?.length) {
			setFile(Array.from(e.target.files)[0]);
		}
	};

	const handleDrop = (e: Array<File>) => {
		if (e.length) {
			setFile(e[0]);
		}
	};

	useEffect(() => {
		(async () => {
			if (file) {
				const parsedQuotes = await parseQuotesXlsx(file);
				const { validatedQuotes, errorsCount } = await validateUploadedQuotesList(parsedQuotes);

				setErrorsCount(errorsCount);
				handleInput(validatedQuotes);
			}
		})();
	}, [file]);

	return (
		<div className={styles.wrap}>
			<Dropzone
				accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				multiple={false}
				onDrop={handleDrop}
			>
				{({ getRootProps }) => {
					return (
						<div className={styles.input} {...getRootProps()}>
							<UploadSVG className={styles.uploadIcon} />
							<div className={styles.uploadText}>
								<input
									id="file-upload"
									type="file"
									accept=".csv, application/vnd.oasis.opendocument.spreadsheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
									onInput={handleUpload}
									// @ts-ignore
									// eslint-disable-next-line no-return-assign
									onClick={e => (e.target.value = null)}
								/>
								<label htmlFor="file-upload" className={styles.uploadLabel}>
									Click to upload
								</label>
								<span>or drag and drop</span>
							</div>
						</div>
					);
				}}
			</Dropzone>
		</div>
	);
};
